import React, {useState} from "react";
import {
    Button,
    Flex,
    FormControl,
    FormLabel,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    useColorModeValue,
    useDisclosure,
    useToast,
    Image,
    VStack,
} from "@chakra-ui/react";
import SignUpModal from "../../../components/signup/signup";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {RiEyeCloseLine} from "react-icons/ri";
import axios from "axios";
import { motion } from "framer-motion";

const MotionFlex = motion(Flex);
const MotionImage = motion(Image);

function SignIn() {
    const textColorSecondary = "gray.400";
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const [show, setShow] = React.useState(false);
    const handleClick = () => setShow(!show);

    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const {isOpen, onClose} = useDisclosure();

    const handleLogin = async () => {
        if (!email || !password) {
            toast({
                title: "Validation Error",
                description: "Please fill in all required fields",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + '/v1/login',
                { email, password }
            );

            const token = response.data.data.token;
            const user = response.data.data.name;

            document.cookie = `token=${token}; path=/`;
            document.cookie = `user=${JSON.stringify(user)}; path=/`;

            if (token && user) {
                toast({
                    title: "Login successful",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                window.location.href = "/admin";
            } else {
                if (response.data.code === 200) {
                    toast({
                        title: "Login failed , Call your IT Team",
                        status: "error",
                        duration: 2000,
                        isClosable: true,
                    });
                }
            }
        } catch (error) {
            toast({
                title: "Login failed",
                description: error.response?.data?.message || "An error occurred. Please try again.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <MotionFlex
            maxW="100%"
            w="100%"
            mx="auto"
            minH="100vh"
            alignItems="center"
            justifyContent="center"
            px={{ base: "15px", sm: "25px", md: "45px" }}
            py={{ base: "15px", sm: "25px", md: "45px" }}
            flexDirection="column"
            backgroundImage={{ base: "none", md: `url(${process.env.PUBLIC_URL}/BG_Login2.png)` }}
            backgroundSize="cover"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundColor={{ base: "white", md: "transparent" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}>

            <MotionFlex
                zIndex="2"
                direction="column"
                w={{ base: "100%", sm: "420px" }}
                maxW="100%"
                bg="white"
                boxShadow={{ base: "none", md: "2xl" }}
                borderRadius="xl"
                mx="auto"
                mb={{ base: "15px", md: "25px" }}
                mr={{ base: "auto", md: "62%" }}
                p={{ base: "20px", md: "40px" }}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}>
                
                <VStack spacing={6}>
                    <MotionImage
                        src={`${process.env.PUBLIC_URL}/logosinaralam.png`}
                        alt="Logo Sinar Alam"
                        maxW="180px"
                        w="100%"
                        h="auto"
                        initial={{ scale: 0.8 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                    />
{/*                     
                    <Heading size="lg" color="gray.800" textAlign="center">
                        Welcome to Super App
                    </Heading> */}
                    
                    {/* <Text color="gray.600" fontSize="md" textAlign="center">
                        Sign in to access your account
                    </Text> */}
                    
                    <FormControl>
                        <FormLabel
                            fontSize='sm'
                            fontWeight='600'
                            color="gray.700"
                            mb='2'>
                            Email<Text as="span" color={brandStars}>*</Text>
                        </FormLabel>
                        <Input
                            variant='filled'
                            fontSize='md'
                            type='email'
                            placeholder='Enter your email'
                            mb='4'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyPress={handleKeyPress}
                            _hover={{ bg: "gray.100" }}
                            _focus={{ borderColor: "blue.400", bg: "white" }}
                            _placeholder={{ color: 'gray.500' }}
                            transition="all 0.2s"
                        />
                        
                        <FormLabel
                            fontSize='sm'
                            fontWeight='600'
                            color="gray.700"
                            mb='2'>
                            Password<Text as="span" color={brandStars}>*</Text>
                        </FormLabel>
                        <InputGroup size='md'>
                            <Input
                                variant='filled'
                                fontSize='md'
                                type={show ? "text" : "password"}
                                placeholder='Enter your password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyPress={handleKeyPress}
                                _hover={{ bg: "gray.100" }}
                                _focus={{ borderColor: "blue.400", bg: "white" }}
                                _placeholder={{ color: 'gray.500' }}
                                transition="all 0.2s"
                            />
                            <InputRightElement>
                                <Icon
                                    color={textColorSecondary}
                                    cursor="pointer"
                                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                    onClick={handleClick}
                                    _hover={{ color: "blue.500" }}
                                />
                            </InputRightElement>
                        </InputGroup>
                        
                        <Button
                            mt="6"
                            fontSize='md'
                            fontWeight='600'
                            w='100%'
                            h='50px'
                            type="submit"
                            isLoading={isLoading}
                            onClick={handleLogin}
                            bgGradient="linear(to-r, blue.400, blue.600)"
                            color="white"
                            _hover={{
                                bgGradient: "linear(to-r, blue.500, blue.700)",
                                transform: "translateY(-2px)",
                                boxShadow: "lg"
                            }}
                            transition="all 0.2s">
                            Sign In
                        </Button>
                    </FormControl>
                </VStack>
                <SignUpModal isOpen={isOpen} onClose={onClose} />
            </MotionFlex>
            {/* <SignUpModal isOpen={isOpen} onClose={onClose} /> */}
            

            {/* <Footer /> */}
            
        </MotionFlex>
    );
}

export default SignIn;
